import React, { useEffect } from 'react'
import { FormControl, makeStyles, Radio, RadioGroup } from '@material-ui/core'
import { useSelector } from 'react-redux'
import { ReportStatus } from '../../root/components/common'
import { getFormattedDate, getReportTypeText } from '../.././../utils'

export const TriggeredReportSelectList = ({
    reports,
    onSelect,
    selectedReport
}) => {
    const { theme } = useSelector(state => state.main)
    const locale = useSelector(state => state.main.locale)
    const defaultSelectedReport = reports?.[0]?.id
    const styles = useStyles()
    useEffect(() => {
        if (!selectedReport) onSelect(defaultSelectedReport)
    }, [])

    if (!reports || !reports.length) {
        return null
    }

    return (
        <div className={styles.container}>
            <FormControl className={styles.root}>
                <RadioGroup defaultValue={defaultSelectedReport}>
                    {reports.map(r => {
                        return (
                            <div className={styles.listItem} key={r.id}>
                                <Radio
                                    id={`last-report-${r.id}`}
                                    checked={selectedReport === r.id}
                                    onChange={() => onSelect(r.id)}
                                    value={r.id}
                                    color={'primary'}
                                />
                                <label
                                    className={styles.listItem}
                                    htmlFor={`last-report-${r.id}`}
                                >
                                    <div className={styles.reportType}>
                                        {getReportTypeText(r, locale)}
                                    </div>
                                    <div className={styles.reportIcon}>
                                        <ReportStatus
                                            theme={theme}
                                            report={r}
                                        />
                                    </div>
                                    <div className={styles.reportDate}>
                                        {getFormattedDate(r.created_at)}
                                    </div>
                                </label>
                            </div>
                        )
                    })}
                </RadioGroup>
            </FormControl>
        </div>
    )
}
const useStyles = makeStyles(theme => ({
    root: {
        width: '100%'
    },
    reportIcon: {
        display: 'flex',
        alignItems: 'center',
        flexBasis: '35px'
    },
    reportType: { flexBasis: '80px' },
    reportDate: { flex: 2 },
    container: { marginBottom: '16px', marginTop: '16px' },
    listItem: {
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center'
    }
}))
